import _ from 'lodash';

import workspace from "../core/workspace";
import {
  SHAPE_PART_ID,
} from "../../../constants";
import sqftShape from "../core/shapes/sqftShape";
import ShapeHelper from "../../../helpers/shapeHelper";
import sqftShapeManager from "./sqftShapeManager";
import sqftSlabManager from "./sqftSlabManager";
import {renderErrorPopup} from "../../../../../api/api-popups";

const sqftShapeIntersectionsManager = {
  resetShapesIntersections() {
    const shapes = workspace.getShapes();
    for (const shape of shapes) {
      if (shape instanceof sqftShape) {
        shape.shapeIntersections.setOverlappedWithShapeIds([]);
      }
    }
  },
  updateShapesIntersections() {
    this.resetShapesIntersections();

    const shapes = workspace.getShapes();
    //console.log("----------------------");
    for (const shape of shapes) {
      if (shape instanceof sqftShape) {
        for (const testShape of shapes) {
          if (testShape instanceof sqftShape
            && shape.id !== testShape.id
          ) {
            const shapeIntersections = ShapeHelper.getTwoShapesIntersections(shape, testShape);
            const shapeIds = Object.keys(shapeIntersections);
            if (shapeIds.length) {
              shape.shapeIntersections.addOverlappedWithShape(+shapeIds[0]);
            } else if (ShapeHelper.checkIfShapeContainsAnother(shape, testShape)) {
              //console.log("shapeId", shape.id);
              //console.log("testShapeId", testShape.id);
              testShape.shapeIntersections.addOverlappedWithShape(shape.id);
              shape.shapeIntersections.addOverlappedWithShape(testShape.id);
            }
          }
        }
        //console.log("shapeId", shape.id);
        //console.log("shape.shapeIntersections.overlappedWithShapeIds", shape.shapeIntersections.overlappedWithShapeIds);
      }
    }
    //this.logShapeFeatureIds()
  },
  logShapeFeatureIds() {
    const shapes = workspace.getShapes();
    for (const shape of shapes) {
      console.log("shape id", shape.id);
      console.log("shape feature id", shape.featureId);
      console.log("shape shapeIntersections overlappedWithShapeIds", shape.shapeIntersections.overlappedWithShapeIds);
    }
  },
  logSnappedShapeGroups() {
    const shapes = workspace.getShapes();
    console.log("------");
    for (const shape of shapes) {
      if (shape instanceof sqftShape) {
        console.log("shape id", shape.id);
        console.log("shape area", shape.getTotalArea());
        console.log("shape getSnappedShapeGroup", shape.shapeAbsolute.getSnappedShapeGroup());
        console.log("shape shapeSlab getSnappedShapeGroup", shape.shapeSlab.shapeAbsolute.getSnappedShapeGroup());
      }
    }
    console.log("------");
  },
  updateSlabPlaceholderFeatureId() {
    const shapes = workspace.getShapes();
    for (const shape of shapes) {
      if (shape instanceof sqftShape
        && shape.partId === SHAPE_PART_ID.slabPlaceHolder
      ) {
        //console.log("update feature shape.shapeIntersections.overlappedWithShapeIds", shape.shapeIntersections.overlappedWithShapeIds);
        if (shape.shapeIntersections.overlappedWithShapeIds.length >= 1) {
          const intersectedShape = sqftShapeManager.getShapeById(shape.shapeIntersections.overlappedWithShapeIds[0]);
          shape.setFeatureId(_.clone(intersectedShape.featureId));
          shape.setSlabParentPartId(_.clone(intersectedShape.slabParentPartId ? intersectedShape.slabParentPartId : intersectedShape.partId));
        }
      }
    }
  },

  showSlabPlaceHolderErrorMessage (
    slabPlaceHolderShapes = sqftSlabManager.getSlabPlaceHolderShapes(),
    callback = new Function()
  ) {
    for (const slabPlaceHolderShape of slabPlaceHolderShapes) {
      //console.log("slabPlaceHolderShape.overlappedWithShapeIds", slabPlaceHolderShape.shapeIntersections.overlappedWithShapeIds);
      if (slabPlaceHolderShape.shapeIntersections.overlappedWithShapeIds.length >= 2) {
        const shapes = sqftShapeManager.getShapeByIds(slabPlaceHolderShape.shapeIntersections.overlappedWithShapeIds);
        if (
          !sqftShapeManager.hasSameSharedFeatureName(shapes)
          && !sqftShapeManager.hasSameFeatureId(shapes)
        ) {

          renderErrorPopup(workspace.intl.formatMessage({id: "sqft.popup.system.slabPlaceholderMultipleOverlap"}));
          callback();
        }
      }
    }
  }
};

export default sqftShapeIntersectionsManager
